export const SET_CURRENT_USER = 'SET_CURRENT_USER';

export const receiveCurrentUser = ( ustate ) => {
  return {
    type: SET_CURRENT_USER,
    ustate: ustate
  }
};



// WEBPACK FOOTER //
// ./common/actions/UstateActions.js